import type { ButtonHTMLAttributes, Ref } from "react";
import { Button as PrimitiveButton } from "../primitives/button";
import { useDesignSystem } from "./DesignSystem";
import "./controls.css";
import "../next-ui/controls.css";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "utility" | "quiet" | "danger";
  size?: "regular" | "compact" | "icon";
  busy?: boolean;
  ref?: Ref<HTMLButtonElement>;
  asChild?: boolean;
};

export function Button({ variant = "secondary", size = "regular", busy = false, disabled, className = "", type = "button", ...props }: ButtonProps) {
  const themed = useDesignSystem();
  const shared = { ...props, type, className: `ui-button ui-button--${variant} ui-button--${size} ${className}`.trim(), disabled: disabled || busy, "aria-busy": busy || undefined };
  // Keep the untouched home on its original DOM/CSS contract, without utility
  // classes leaking from the primitives. Both paths share this app adapter.
  if (!themed) {
    const { asChild: _asChild, ...native } = shared;
    return <button {...native} />;
  }
  const variants = { primary: "default", secondary: "outline", utility: "secondary", quiet: "ghost", danger: "destructive" } as const;
  return <PrimitiveButton {...shared} variant={variants[variant]} size={size === "icon" ? "icon" : size === "compact" ? "sm" : "default"} />;
}
